import http from './index'
// function logging (dto, version = 1) {
//   return http.post(`/logging/v${version}/dapeigou`, dto)
// }


// function getAd () {
//   return http.get(`/ymyp/door/getMiddleBannerList`)
// }
function getInfo(id){
  return http.get(`/printLabel/info/`+id)
}
export default {
  getInfo
}



// WEBPACK FOOTER //
// ./src/api/api.js